module.exports = __webpack_public_path__ + "static/img/Warehousing supervision picture.174e69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/Warehousing supervision picture.png
// module id = SPKc
// module chunks = 44